import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import {
	toggleableStateKeptInSessionStorageFactory, TRUE
} from './toggleable-state-kept-in-session-storage-factory';
import { isNonProductionBuild } from './non-production-build';

const MOCKED_BACKEND_IS_ACTIVE_STORAGE_KEY = 'mocked-backend-is-active';
const DEMO_MODE_IS_ACTIVE_STORAGE_KEY = 'demo-mode-is-active';

export class MockedBackendState extends toggleableStateKeptInSessionStorageFactory(MOCKED_BACKEND_IS_ACTIVE_STORAGE_KEY) {

	private static readonly _isApiMockPluginsIniting$ = new BehaviorSubject(false);

	static isApiMockPluginsIniting$ = MockedBackendState._isApiMockPluginsIniting$.asObservable();

	static isNoApiMockPluginsIniting$ = MockedBackendState._isApiMockPluginsIniting$.pipe(map(v => !v));

	// Production ships no mocked backend, so a flag set from DevTools must not switch the app into it
	static override get isActive(): boolean {
		return isNonProductionBuild() && super.isActive;
	}

	static get isDemoMode(): boolean {
		try {
			return this.isActive && sessionStorage.getItem(DEMO_MODE_IS_ACTIVE_STORAGE_KEY) === TRUE;
		} catch {
			return false;
		}
	}

	static get isActiveAndNotDemoMode(): boolean {
		return this.isActive && !this.isDemoMode;
	}

	static get isApiMockPluginsIniting(): boolean {
		return this._isApiMockPluginsIniting$.value;
	}

	static apiMockPluginsInitStarted(): void {
		this._isApiMockPluginsIniting$.next(true);
	}

	static apiMockPluginsInitFinished(): void {
		this._isApiMockPluginsIniting$.next(false);
	}

	static reloadInDemoMode(): void {
		if (MockedBackendState.isDemoMode)
			return;

		try {
			sessionStorage.setItem(DEMO_MODE_IS_ACTIVE_STORAGE_KEY, TRUE);

			this.setAndReloadPage(true);
		} catch {
			// ignore
		}
	}

	static reloadInMockMode(): void {
		if (MockedBackendState.isActive)
			return;

		this.setAndReloadPage(true);
	}

	static reloadInOldDesign(): void {
		if (!MockedBackendState.isDemoMode)
			return;

		try {
			sessionStorage.removeItem(DEMO_MODE_IS_ACTIVE_STORAGE_KEY);

			this.setAndReloadPage(false);
		} catch {
			// ignore
		}
	}
}
